var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-box-second flex-align-center"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"more-box"},[_vm._t("default",function(){return [_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.gotoLink}},[_vm._v("更多")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }